import React from 'react';
import { type ColumnDef } from '@tanstack/react-table';
import { Badge, Button, Table } from '@shared/components';
import { PermissionGuard } from '@/features/auth';
import type { ProductAddOnGroupRecord } from '../services/addonGroup.types';

interface Props {
    data: ProductAddOnGroupRecord[];
    onRemove: (groupId: string) => void;
}

export const ProductAddOnGroupDataTable: React.FC<Props> = ({ data, onRemove }) => {
    const columns: ColumnDef<ProductAddOnGroupRecord>[] = [
        {
            accessorKey: 'name',
            header: 'Group Name',
            cell: (info) => (
                <span className="font-semibold text-sm">{info.getValue() as string}</span>
            ),
        },
        {
            id: 'members',
            header: 'Members',
            cell: (info) => {
                const count = info.row.original.addons?.length ?? info.row.original.addons_count;
                return (
                    <Badge variant="outline">
                        {count ?? 0}
                    </Badge>
                );
            },
        },
        {
            id: 'status',
            header: 'Status',
            cell: (info) => {
                const retired = !!info.row.original.retired_at;
                return retired ? (
                    <Badge variant="error">Retired</Badge>
                ) : (
                    <Badge variant="success">Active</Badge>
                );
            },
        },
        {
            id: 'actions',
            header: 'Actions',
            enableSorting: false,
            cell: (info) => (
                <PermissionGuard permission={{ resource: 'smr', action: 'product-addon-group.delete' }}>
                    <Button
                        size="xs"
                        variant="outline"
                        onClick={() => onRemove(info.row.original.id)}
                    >
                        Remove
                    </Button>
                </PermissionGuard>
            ),
        },
    ];

    return <Table<ProductAddOnGroupRecord> data={data} columns={columns} enableSorting={false} />;
};
